export const routes = {
  auth: 'auth',
  ims: 'ims',
  dashboard: 'dashboard',
  comingSoon: 'coming-soon',
  investments: 'investments',
  details: 'details',
  transact: 'transact',
  tracking: 'tracking',
  correspondence: 'correspondence',
  otherApps: 'other-apps',
  settings: 'settings',
  legal: 'legal',
  support: 'support',
  loginUnavailable: 'login-unavailable'
} as const;

export const isOnHomePage = (pathName: string) => pathName.endsWith(routes.dashboard);
